<!--
 * @Author: baiwei
 * @Date: 2020-04-24 11:16:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-21 16:47:22
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div>
        <rcTable ref="rcTable"
                 :tableAttr="tableAttr"
                 @onSelectChange="selectedChange">
            <div slot="tootipL">
                <Button type="primary"
                        @click="configureUserGroupPolices"
                        :disabled="!hasPermission('CH02100201') || disabled">
                    {{$t('配置权限')}}
                </Button>
                <Button :disabled="!selected.length || !hasPermission('CH02100202') || disabled"
                        @click="remove()">
                    {{$t('移除')}}
                </Button>
            </div>
        </rcTable>
        <configureUserGroupPolices ref="configureUserGroupPolices"
                                   @refresh="refresh"></configureUserGroupPolices>
    </div>
</template>
<script>
import rcTable from '@c/basic/rcTable'
import configureUserGroupPolices from '../../components/configureusergrouppolices'
import API from '@/service/api'
export default {
    name: 'polices',
    components: {
        rcTable,
        configureUserGroupPolices
    },
    props: ['disabled'],
    data () {
        return {
            selected: [],
            tableAttr: {
                source: {
                    type: 'staticData',
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                searchShow: false,
                // columnsChooseShow: true,
                isMultiSelect: true,
                referenceVal: 1000,
                pageData: {
                    pageWays: 'client'
                },
                columns: [
                    {
                        title: this.$t('权限标识'),
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => h('span', { attrs: { title: params.row.policyName } }, params.row.policyName)
                    },
                    {
                        title: this.$t('分类'),
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        render: (h, params) => h('span', { attrs: { title: params.row.resourceTypes } }, params.row.resourceTypes)
                    },
                    {
                        title: this.$t('描述'),
                        className: 'ellipsis',
                        resizable: false,
                        width: 150,
                        render: (h, params) => h('span', { attrs: { title: params.row.description || '--' } }, params.row.description || '--')
                    },
                    {
                        title: this.$t('关联资源'),
                        className: 'ellipsis',
                        resizable: false,
                        width: 100,
                        render: (h, params) => h('span', { attrs: { title: params.row.hpcClusterName || '--' } }, params.row.hpcClusterName || '--')
                    },
                    {
                        title: this.$t('授权时间'),
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 170,
                        render: (h, params) => h('span', { attrs: { title: params.row.authorizedTime } }, params.row.authorizedTime)
                    },
                    {
                        title: this.$t('操作'),
                        resizable: false,
                        // align: 'center',
                        fixed: 'right',
                        width: 70,
                        render: (h, params) => {
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, [
                                h('a', {
                                    class: { 'disabled-per': !this.hasPermission('CH0208') || this.disabled },
                                    on: { click: () => this.hasPermission('CH0208') && !this.disabled && this.remove(params.row.policySid) }
                                }, this.$t('移除'))
                            ])
                        }
                    }
                ]
            }
        }
    },
    created () {
    },
    methods: {
        initData (data, groupSid) {
            this.groupSid = groupSid
            this.tableAttr.source.tableData = {
                totalRows: data.length,
                dataList: data
            }
            this.$refs.rcTable.refreshTable()
        },
        selectedChange (selection) {
            this.selected = selection
        },
        refresh () {
            this.$emit('refresh')
        },
        configureUserGroupPolices () {
            this.$refs.configureUserGroupPolices.open(this.groupSid)
        },
        remove (id) {
            this.$Modal.confirm({
                title: this.$t('移除'),
                content: this.$t(`确定要移除${id ? '该' : '所选'}用户组权限`),
                okText: this.$t('确定'),
                cancelText: this.$t('取消'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.ACCESS_USERGROUP_POLICY, false), {
                        data: {
                            groupSid: this.groupSid,
                            policies: id ? [id] : this.selected.map(item => item.policySid)
                        }
                    }).then(res => {
                        this.refresh()
                    })
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
</style>
